import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialog as MatDialog,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ExdrLanguageService } from 'src/app/languages/services/exdr-language.service';

import { AuthService } from 'src/app/shared/services/auth.service';
import { JoinGroupDialogComponent } from '../join-group-dialog/join-group-dialog.component';

@Component({
  selector: 'xcdrs-choose-subgroup',
  templateUrl: './choose-subgroup.component.html',
  styleUrls: ['./choose-subgroup.component.scss'],
  standalone: true,
  imports: [
    CommonModule, MatButtonModule,
    FormsModule, ReactiveFormsModule, MatIconModule,
    MatFormFieldModule, MatInputModule, TranslateModule,
    MatProgressSpinnerModule
  ]
})

export class ChooseSubGroupComponent implements OnInit {

  isLoading: boolean = false;
  loading: boolean = false;
  groupJoined: boolean = false;
  idenediGroupId: string = '';

  // subGroups: { GroupIdenedi: string, GroupName: string, GroupMembershipOption: string, isJoined: boolean }[] = [];
  subGroups: any[] = [];
  selectedSubGroup: any | null = null;

  constructor(
    @Optional() public dialogRef: MatDialogRef<ChooseSubGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private authService: AuthService,
    private exdrLangService: ExdrLanguageService
  ) { }

  ngOnInit(): void {
    console.log('SubgroupDialogData', this.data)
    this.idenediGroupId = this.authService.idenediGroupId;
    this.subGroups = this.data?.subGroups || []
  }

  onSubGroupSelect(unit: any): void {
    this.selectedSubGroup = unit;
    this.joinSubGroup();
  }

  joinSubGroup() {
    this.dialog.open(JoinGroupDialogComponent, {
      autoFocus: false,
      disableClose: true,
      direction: this.exdrLangService.currentLanguage.isRtl ? 'rtl' : "ltr",
      data: {
        membershipOption: this.selectedSubGroup.GroupMembershipOption,
        groupName: this.selectedSubGroup.GroupName,
        groupId: this.selectedSubGroup.Idenedi,
        allowedDomains: this.selectedSubGroup?.GroupSettings?.GroupMembershipEmailAddressDomains || [],
        callFrom: 'GROUP_GUARD'
        // allowedDomains: this.selectedSubGroup.GroupSearchResult.MembershipOptionData
      }
    }).afterClosed().subscribe((status: string) => {
      console.log('@joinGroupDialog', status);
      if (status?.toLowerCase() === 'joined') {
        this.subGroups = this.subGroups.map(sg => ({ ...sg, isJoined: this.selectedSubGroup.GroupIdenedi === sg.GroupIdenedi ? true : sg.isJoined }))
        this.groupJoined = true;
        localStorage.setItem('skipSubgroupSelection', 'true');
      }
    })
  }

  onDone() {
    this.dialogRef.close({ closed: true });
  }

  onCancel(): void {
    localStorage.setItem('skipSubgroupSelection', 'true');
    this.onDone();
  }
}
